import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { TextInputComponent } from 'app/phoenix2/common/components/text-input/text-input.component';
import { ProvideParentFormDirective } from './components/provide-parent-form.directive';
import { RadioInputComponent } from 'app/phoenix2/common/components/radio-input/radio-input.component';
import { HeadingComponent } from 'app/phoenix2/common/components/heading/heading.component';
import { ControlGroupInputComponent } from 'app/phoenix2/common/components/control-group/control-group-input.component';
import { HappyModalComponent } from 'app/phoenix2/common/services/happy-modal/happy-modal.component';
import { HappyModalService } from './services/happy-modal.service';
import { HappyStepperComponent } from 'app/phoenix2/common/components/happy-stepper/happy-stepper.component';
import { HappyStepComponent } from 'app/phoenix2/common/components/happy-stepper/happy-step/happy-step.component';
import { SimpleInfoComponent } from '../../shared/components/modal/simple-info.component';
import { HappyTextareaInputComponent } from 'app/phoenix2/common/components/happy-textarea-input/happy-textarea-input.component';
import { HappyInputTemplateComponent } from 'app/phoenix2/common/components/happy-template-input/happy-input-template.component';
import { HappyCheckboxControlComponent } from 'app/phoenix2/common/components/happy-checkbox-control/happy-checkbox-control.component';
import { HappyListComponent } from 'app/phoenix2/common/components/happy-list/happy-list.component';
import { DetailsGroupComponent } from './components/details-group/details-group.component';
import { HappyDropdownComponent } from 'app/phoenix2/common/components/happy-dropdown/happy-dropdown.component';
import { HappyNumberInputComponent } from 'app/phoenix2/common/components/happy-number-input/happy-number-input.component';

@NgModule({
  imports: [FormsModule, CommonModule, SharedModule, ReactiveFormsModule],
  declarations: [
    TextInputComponent,
    ProvideParentFormDirective,
    RadioInputComponent,
    HeadingComponent,
    ControlGroupInputComponent,
    HappyModalComponent,
    HappyModalComponent,
    HappyStepperComponent,
    HappyStepComponent,
    HappyTextareaInputComponent,
    HappyInputTemplateComponent,
    HappyCheckboxControlComponent,
    HappyListComponent,
    DetailsGroupComponent,
    HappyDropdownComponent,
    HappyNumberInputComponent
  ],
  providers: [HappyModalService],
  entryComponents: [SimpleInfoComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    TextInputComponent,
    RadioInputComponent,
    ProvideParentFormDirective,
    HeadingComponent,
    HappyStepperComponent,
    HappyStepComponent,
    ControlGroupInputComponent,
    DetailsGroupComponent,
    HappyTextareaInputComponent,
    HappyCheckboxControlComponent,
    HappyInputTemplateComponent,
    HappyListComponent,
    HappyDropdownComponent,
    HappyNumberInputComponent
  ]
})
export class PhoenixCommonModule {}



// WEBPACK FOOTER //
// ./src/app/phoenix2/common/phoenix-common.module.ts